import { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./global.css";
import AppProviders from "./providers/ContextProviders";
import AppRoutes from "./routes";
import DeviceGuard from "./DeviceGuard";
import { Auth0Provider } from "@auth0/auth0-react";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Fragment>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppProviders>
          <DeviceGuard>
            <AppRoutes />
          </DeviceGuard>
        </AppProviders>
      </BrowserRouter>
    </Auth0Provider>
  </Fragment>
);
